import { render, staticRenderFns } from "./detailes.vue?vue&type=template&id=c2b7ea04&scoped=true&"
import script from "./detailes.vue?vue&type=script&lang=js&"
export * from "./detailes.vue?vue&type=script&lang=js&"
import style0 from "./detailes.vue?vue&type=style&index=0&id=c2b7ea04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b7ea04",
  null
  
)

export default component.exports